
import React from 'react';
import './Slideshow.css'

// TODO for imagur we just add `m.jpg` for thumbnail and `.jpg` for full size
const thumbnail = url => {
	if (url.includes('googleusercontent')) {
		return url + '=w300-h200-c'
	}
	return url
	// return url + '=s408'
	// return url + '=s300'
}

const fullsize = url => {
	if (url.includes('googleusercontent')) {
		return url + '=s16383'
	}
	return url
}


const Slideshow = ({ urls, setOpen }) => {
	const [slideIndex, setSlideIndex] = React.useState(0);
	const plusSlides = (n) => {
		const newN = Math.max(0, Math.min(slideIndex + n, urls.length - 1))
	  	setSlideIndex(newN);
	}

	if (urls.length === 1) {
		return  <img key={urls[0]} onClick={() => setOpen(fullsize(urls[0]))} src={thumbnail(urls[0])} style={{ "width": "100%" }}/>
	}

	return <React.Fragment>
		<div className="slideshow-container">
			{urls.map((url, urli) => {
				const display = urli === slideIndex ? "block" : "none";
				return <div key={url} className="mySlides fade" style={{ "display": display }}>
				    <div className="numbertext">{urli + 1} / {urls.length}</div>
				    <img onClick={() => setOpen(fullsize(url))} src={thumbnail(url)} style={{ "width": "100%" }}/>
				    {/*<div className="text">Caption Text</div>*/}
				  </div>
			})}
		  <a className="prev" onClick={() => plusSlides(-1)}>&#10094;</a>
		  <a className="next" onClick={() => plusSlides(1)}>&#10095;</a>
		</div>
		<br/>
		<div style={{ "textAlign": "center" }}>
			{urls.map((url, urli) => {
				const className = urli === slideIndex ? "dot active" : "dot";
		  		return <span key={url} className={className} onClick={() => setSlideIndex(urli)}></span>
			})}
		</div>
	</React.Fragment>
}

export default Slideshow;